<div class="ticker">
  <div
    class="icon-wrapper"
    [class]="getIconClass()"
  >
    <i [class]="'dx-icon dx-icon-' + icon"></i>
  </div>
  <div class="middle">
    <div class="title">
      {{ titleText }}
    </div>
    <div class="total">
      {{
      total === null
        ? (getTotal | apply: data | currency: 'USD':'$':'1.0-0')
        : total
      }}
    </div>
  </div>
  <div *ngIf="percentage !== 0"
       class="percentage"
       [class]="percentage > 0 ? 'positive': 'negative'"
  >
    <div [class]="'dx-icon-'+ (percentage > 0 ? 'spinup' : 'spindown')"></div>
    <i class="value"></i>
    <span>{{ abs(percentage) }}%</span>
  </div>
</div>
